(function () {
  function initVrsContactForms(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var forms = root.querySelectorAll('.vrs-contactform');

    forms.forEach(function (container) {
      if (container.dataset.vrsContactformInitialized === 'true') {
        return;
      }

      var inquirySelect = container.querySelector('#VrsContactForm-inquiry');
      var secondaryRow = container.querySelector('.vrs-contactform__secondary-row');
      var orderField = container.querySelector('.vrs-contactform__order-field');
      var orderInput = container.querySelector('#VrsContactForm-order-number');
      var otherField = container.querySelector('.vrs-contactform__custom-inquiry-field');
      var otherInput = container.querySelector('#VrsContactForm-other-inquiry');

      if (!inquirySelect || !secondaryRow || !orderField || !orderInput || !otherField || !otherInput) {
        return;
      }

      var orderInquiryValues = ['order issue', 'shipping', 'return'];

      function updateConditionalFields() {
        var selectedValue = (inquirySelect.value || '').trim().toLowerCase();
        var showOrderField = orderInquiryValues.indexOf(selectedValue) !== -1;
        var showOtherField = selectedValue === 'other';

        orderField.hidden = !showOrderField;
        orderInput.disabled = !showOrderField;
        orderInput.required = false;

        otherField.hidden = !showOtherField;
        otherInput.disabled = !showOtherField;
        otherInput.required = showOtherField;

        if (!showOrderField) {
          orderInput.value = '';
        }

        if (!showOtherField) {
          otherInput.value = '';
        }

        if (showOrderField || showOtherField) {
          secondaryRow.classList.remove('vrs-contactform__secondary-row--single');
        } else {
          secondaryRow.classList.add('vrs-contactform__secondary-row--single');
        }
      }

      inquirySelect.addEventListener('change', updateConditionalFields);
      updateConditionalFields();
      container.dataset.vrsContactformInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVrsContactForms(document);
    });
  } else {
    initVrsContactForms(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVrsContactForms(event.target);
  });
})();

(function () {
  function initVrsContactOrderHelp(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var forms = root.querySelectorAll('.vrs-contactform');

    forms.forEach(function (container) {
      var orderField = container.querySelector('.vrs-contactform__order-field');
      var orderInput = container.querySelector('#VrsContactForm-order-number');

      if (!orderField || !orderInput || orderField.dataset.vrsOrderHelpInit === 'true') {
        return;
      }

      orderField.dataset.vrsOrderHelpInit = 'true';
      orderField.classList.add('vrs-contactform__order-field--help');

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'vrs-contactform__order-help-trigger';
      trigger.setAttribute('aria-label', 'Order number help');
      trigger.setAttribute('aria-expanded', 'false');

      var tooltip = document.createElement('div');
      tooltip.className = 'vrs-contactform__order-help-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      tooltip.innerHTML = 'The order number usually looks like <strong>#VRS1001</strong>.<br>You can find it in your confirmation email.';

      orderField.appendChild(trigger);
      orderField.appendChild(tooltip);

      var pinned = false;

      function showTooltip() {
        tooltip.classList.add('is-visible');
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function hideTooltip(force) {
        if (pinned && !force) return;
        tooltip.classList.remove('is-visible');
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('mouseenter', function () {
        if (!pinned) showTooltip();
      });

      trigger.addEventListener('mouseleave', function () {
        if (!pinned) hideTooltip(true);
      });

      trigger.addEventListener('focus', function () {
        showTooltip();
      });

      trigger.addEventListener('blur', function () {
        window.setTimeout(function () {
          if (!pinned && !orderField.contains(document.activeElement)) {
            hideTooltip(true);
          }
        }, 0);
      });

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        pinned = !pinned;

        if (pinned) {
          showTooltip();
        } else {
          hideTooltip(true);
        }
      });

      tooltip.addEventListener('mouseenter', function () {
        if (pinned) showTooltip();
      });

      tooltip.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      document.addEventListener('click', function (event) {
        if (!orderField.contains(event.target)) {
          pinned = false;
          hideTooltip(true);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          pinned = false;
          hideTooltip(true);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVrsContactOrderHelp(document);
    });
  } else {
    initVrsContactOrderHelp(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVrsContactOrderHelp(event.target);
  });
})();
